import { define, is, nullable, number, optional } from '@subaio/validation'

import type { DefaultFields } from './DefaultProps'

export const fieldNumber = ({
	requiredErrorMessage = 'This field is required',
	invalidErrorMessage = 'Has to be a number',
}: DefaultFields = {}) =>
	define<number>('fieldNumber', (value) => {
		const isValidNumber = is(value, optional(number()))
		if (!isValidNumber) return invalidErrorMessage
		if (is(value, number())) return true
		return requiredErrorMessage
	})

export const fieldNumberOptional = ({
	invalidErrorMessage = 'Has to be a number',
}: Pick<DefaultFields, 'invalidErrorMessage'> = {}) =>
	define<number | undefined | null>(
		'fieldNumberOptional',
		(value) => is(value, optional(nullable(number()))) || invalidErrorMessage,
	)
